import { useSyncExternalStore } from "react";
import { useSearchParams } from "react-router-dom";
import { getAppliedReferral, referralEvent, saveAppliedReferral } from "../../helpers/applied.referral";

const subscribe = (callback) => {
  window.addEventListener(referralEvent, callback);
  window.addEventListener("storage", callback);
  return () => {
    window.removeEventListener(referralEvent, callback);
    window.removeEventListener("storage", callback);
  };
};
const snapshot = () => JSON.stringify([getAppliedReferral(), localStorage.getItem("referral_name") || ""]);

export default function useAppliedReferral() {
  const [code, name] = JSON.parse(useSyncExternalStore(subscribe, snapshot));
  const [params, setParams] = useSearchParams();
  const cancel = () => {
    saveAppliedReferral("");
    const next = new URLSearchParams(params);
    ["referral_code", "referral", "referrer", "name", "username"].forEach((key) => next.delete(key));
    setParams(next, { replace: true });
  };
  return { code, name, cancel };
}
